var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._m(0),_c('div',{staticClass:"copyright"},[_vm._v(" Copyright "),_c('a-icon',{attrs:{"type":"copyright"}}),_vm._v(" 2023 "),_c('span',[_vm._v("HcIt")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},[_c('a',{attrs:{"href":"","target":"_blank"}},[_vm._v("HcManagePlatform 首页")])])
}]

export { render, staticRenderFns }